/* eslint-disable no-param-reassign */
/* eslint-disable radix */
/* eslint-disable import/no-cycle */
import { MapUnit } from 'src/types/unit.type';
import { MapMarkerController } from './MapMarkerController';

export class UnitsController {
  markerController: MapMarkerController | undefined = undefined;

  setMarkerController = (markerController: MapMarkerController) => {
    this.markerController = markerController;
  };

  addUnit = (unit: MapUnit) => {
    if (this.markerController !== undefined && !this.markerController.markers[unit.id]) {
      this.markerController.loadUnit(unit);
    }
  };

  loadUnits = (units: MapUnit[]) => {
    if (this.markerController !== undefined) {
      // eslint-disable-next-line prefer-destructuring
      const firstLoad = this.markerController.firstLoad;

      if (firstLoad) {
        this.markerController.clearUnitMarkers();
      }

      this.markerController.loadUnits(units);
      this.markerController.firstLoad = false;
    }
  };
}
